import { useLang } from '../../../../../../../../hooks/use-lang';
import { useImageStore } from '../../../../../../../../store/use-image-store';
import { LangType } from '../../../../../../../../helpers/lang';
import { useFocusOnOpen } from '../../../../../../../../hooks/use-focus-on-open';
import { useDishStore } from '../../../../../../../../store/use-dish-store';

export const useMenuInformerCreateDishModalStep1 = () => {
  const { t } = useLang();

  const focusRef = useFocusOnOpen<HTMLInputElement>(true);
  const { postImage, isLoading: isLoadingImage } = useImageStore();

  const { dish, handleUpdateDish } = useDishStore();

  const handleChangeName = (e: LangType) => {
    handleUpdateDish({ name: e });
  };

  const handleChangeDescription = (e: LangType) => {
    handleUpdateDish({
      specs: {
        ...dish?.specs,
        full_desc: e,
      },
    });
  };

  const handleChangePhoto = async (e?: File[]) => {
    if (!e) {
      handleUpdateDish({ images: undefined });
      return;
    }

    const formData = new FormData();
    formData.append('image', e[0]);
    formData.append('set_expired', 'true');
    const resp = await postImage(formData);
    if (resp) {
      handleUpdateDish({ images: { ...dish?.images, main: { ...resp } } });
    }
  };

  const handleChangeActualCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateDish({
      prices: {
        ...dish?.prices,
        primary: { ...dish?.prices?.primary, price: Number(e.target.value) },
      },
    });
  };

  const handleChangeTimeToDo = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateDish({
      ...dish,
      specs: { ...dish?.specs, cooking_time_to: e.currentTarget.value },
    });
  };

  return {
    t,
    isLoadingImage,
    focusRef,
    dish,
    handleChangeName,
    handleChangeDescription,
    handleChangePhoto,
    handleChangeActualCost,
    handleChangeTimeToDo,
  };
};
